function marquee() {
    const marquee = document.querySelectorAll('.marquee');

    if(marquee.length > 0) {
        marquee.forEach(el=> {
            const marqueeW = el.offsetWidth;
            const marqueeH = el.offsetHeight;
            const marqueeItem = el.querySelector('.marquee__item');
            const marqueeItemW = marqueeItem.offsetWidth;

            let marqueeItemCount = Math.ceil((marqueeW / marqueeItemW)) * 2;

            for (let i = 0; i < marqueeItemCount; i++) {
                const clonedMarqueeItem = marqueeItem.cloneNode(true);
    
                el.querySelector('.marquee__list').appendChild(clonedMarqueeItem);
            }


            if(window.innerWidth <= 1241) {
                document.addEventListener('scroll', ()=> {
                    if(window.scrollY >= (el.offsetTop - window.innerHeight)) {
                        let elOffset = window.scrollY - el.offsetTop;

                        el.querySelector('.marquee__list').style.transform = `translateX(${elOffset / 4}px)`;

                        if(window.scrollY >= (el.offsetTop + marqueeH)) {
                            el.querySelector('.marquee__list').style.transform = `translateX(0px)`;
                        }
                    }
                });
            }
        });
    }
}

export default marquee;